// Utility functions for exporting and importing stock items as CSV

// Convert an array of stock items to a CSV string with headers
// For export: include both customerName and clientId (for clarity)
export function stockItemsToCSV(items, customers = []) {
  if (!items || !items.length) return '';
  // Find customer name from clientId
  const clientIdToName = {};
  if (Array.isArray(customers)) {
    customers.forEach(c => { clientIdToName[c.id] = c.name; });
  }
  // Export both customerName and clientId for reference
  const headers = [
    'productCode', 'barcode', 'labelSize', 'minQty', 'currentQty',
    'customerName', 'clientId', 'mainCategory', 'variantDesc', 'cost', 'notes'
  ];
  const escape = v => (
    v == null ? '' : String(v).replace(/"/g, '""')
  );
  const headerLine = headers.join(',');
  const rows = items.map(item =>
    headers.map(h => {
      if (h === 'customerName') {
        return `"${escape(item.customerName || clientIdToName[item.clientId] || '')}"`;
      }
      return `"${escape(item[h])}"`;
    }).join(',')
  );
  return [headerLine, ...rows].join('\r\n');
}



// Parse a CSV string into an array of stock item objects
// For import: expect 'customerName' (not clientId)
export function csvToStockItems(csv) {
  // Simple CSV parsing (assumes no newlines in values, headers present)
  const lines = csv.split(/\r?\n/).filter(Boolean);
  if (!lines.length) return [];
  const headers = lines[0].split(',').map(h => h.replace(/^"|"$/g, ''));
  const items = lines.slice(1).map(line => {
    const values = line.match(/("([^"]|"")*"|[^,]*)/g)?.map(v => v.replace(/^"|"$/g, '').replace(/""/g, '"')) || [];
    const obj = {};
    headers.forEach((h, i) => { obj[h] = values[i] || ''; });
    // For compatibility: if clientId is present but customerName is not, try to infer customerName (optional)
    return obj;
  });
  return items;
}

